import React from 'react';
import { motion } from 'framer-motion';
import { Moon, Zap, Brain, HeartPulse } from 'lucide-react';
const results = [{
  icon: Moon,
  text: 'Dormir mejor y despertar con más energía.'
}, {
  icon: Zap,
  text: 'Mantener energía más estable durante el día.'
}, {
  icon: Brain,
  text: 'Pensar con mayor claridad y sentir menos agobio mental.'
}, {
  icon: HeartPulse,
  text: 'Favorecer un estilo de vida que apoye un peso saludable y un mejor bienestar general.'
}];
export const ResultsSection: React.FC = () => {
  return <section className="py-20 lg:py-28 bg-brand-emerald text-white" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-121">
        <motion.div className="text-center max-w-3xl mx-auto mb-16" initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-122">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-white" data-id="element-123">
            Imagina cómo podría sentirse tu vida dentro de 21 días.
          </h2>
          <p className="text-lg text-brand-offwhite/90 mt-5" data-id="element-124">
            Si aplicas el método de forma constante, estos son algunos de los
            beneficios que muchas personas buscan al mejorar sus hábitos
            relacionados con el manejo del estrés.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-20" data-id="element-125">
          {results.map((result, index) => {
          const Icon = result.icon;
          return <motion.div key={index} className="flex flex-col items-center text-center gap-4" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: index * 0.1
          }} data-id="element-126">
                <div className="w-16 h-16 bg-white/10 rounded-full flex items-center justify-center backdrop-blur-sm" data-id="element-127">
                  <Icon className="w-8 h-8 text-brand-mint" data-id="element-128" />
                </div>
                <p className="text-lg font-medium text-brand-offwhite" data-id="element-129">
                  {result.text}
                </p>
              </motion.div>;
        })}
        </div>

        <motion.div className="max-w-4xl mx-auto bg-white/5 border border-white/10 rounded-2xl p-8 backdrop-blur-md" initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} data-id="element-130">
          <div className="flex flex-col md:flex-row justify-center items-center gap-6 md:gap-12 text-center md:divide-x divide-white/20" data-id="element-131">
            <div className="px-6 w-full md:w-auto" data-id="element-132">
              <span className="block text-4xl font-bold text-brand-mint mb-2" data-id="element-133">
                21 Días
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-134">
                Método paso a paso
              </span>
            </div>
            <div className="px-6 w-full md:w-auto pt-6 md:pt-0 border-t border-white/20 md:border-t-0" data-id="element-135">
              <span className="block text-4xl font-bold text-brand-mint mb-2" data-id="element-136">
                6 Módulos
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-137">
                Aplicación sencilla
              </span>
            </div>
            <div className="px-6 w-full md:w-auto pt-6 md:pt-0 border-t border-white/20 md:border-t-0" data-id="element-138">
              <span className="block text-3xl font-bold text-brand-mint mb-2" data-id="element-139">
                Acceso inmediato
              </span>
              <span className="text-sm uppercase tracking-wider font-medium text-white/80" data-id="element-140">
                Descarga al instante
              </span>
            </div>
          </div>
        </motion.div>

        <div className="text-center mt-16" data-id="element-141">
          <a href="#pricing" className="inline-block px-8 py-4 text-lg font-bold text-brand-emerald bg-white hover:bg-brand-offwhite rounded-full shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-center" data-id="element-142">
            QUIERO SENTIRME MEJOR — $9.99
          </a>
        </div>
      </div>
    </section>;
};